import styled from 'styled-components';
import { CloseBold } from '@elfsight/icons';
import { Icon, type IconProps } from '@elfsight/lib-icon';
import { getColorWithAlpha, Show } from '@elfsight/lib-utils';
import { createReadableClass } from '@elfsight/widget-utils';
import { useLingui } from '@lingui/react/macro';
import { useSettings } from '@wu/widget-core';
import { useCountdownTimerState } from '../../countdown-timer-state-context';
import { ElementBase } from './element-base';

export function CloseButton() {
  const { t } = useLingui();

  const { showCloseButton } = useSettings();
  const { closeWidget } = useCountdownTimerState();

  return (
    <Show when={showCloseButton}>
      <Button
        aria-label={t`Close`}
        onClick={() => closeWidget({ memorize: true })}
      >
        <Cross />
      </Button>
    </Show>
  );
}

export const Button = styled(ElementBase).attrs({
  as: 'button',
  className: createReadableClass({ component: 'element-close-button' })
})`
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  width: 24px;
  height: 24px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  position: absolute;
  background: none;
  border: none;
  transition: background 0.3s ease;
  border-radius: 50%;

  &:hover,
  &:focus {
    background: ${({
      theme: {
        heading: { color }
      }
    }) => getColorWithAlpha(color, 0.2)};
  }
`;

const Cross = styled(Icon).attrs(
  ({
    theme: {
      heading: { color }
    }
  }) => ({
    className: createReadableClass({
      component: 'element-close-button',
      element: 'icon'
    }),
    component: CloseBold,
    size: 12,
    fill: getColorWithAlpha(color, 0.5)
  })
)<Partial<IconProps>>``;
